import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

import Section, { Content } from './Section';
import ImageShortcut from './ImageShortcut';

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${breakpoints.medium`
  `};

  ${breakpoints.large`
  `};
`;

const ImageShortcutWrapper = styled.div`
  flex: 0 0 100%;
  padding: 0 5px 10px;
  ${breakpoints.medium`
	flex: 0 0 50%;
    :nth-child(1),
    :nth-child(4n) {
		flex: 0 0 100%;
    }
  `};

  ${breakpoints.large`
	flex: 0 0 33.33%;
	max-width: 33.33%;
    :nth-child(4n),
    :nth-child(4n + 1) {
		flex: 0 0 66.66%;
		max-width: 66.66%;
    }
  `};
`;

export default function ImageShortcutsSection({ shortcuts }) {
  const imageShortcutsList = shortcuts.map(
    ({ id, url, image, title, subtitle }) => (
		<ImageShortcutWrapper key={id}>
			<ImageShortcut
			  url={url}
			  image={image}
			  title={title}
			  subtitle={subtitle}
			  className="image-shortcut"
			/>
		</ImageShortcutWrapper>
    )
  );

  return (
    <Section>
      <Content>
        <Grid>{imageShortcutsList}</Grid>
      </Content>
    </Section>
  );
}

ImageShortcutsSection.propTypes = {
  shortcuts: PropTypes.array.isRequired
};
